/**
 * English language package.
*/
export default {
    'profile': 'Profile',
    'changeLanguage': 'Change Language',
    'password': 'PASSWORD',

    'inbox': 'Inbox',
    'outbox': 'Outbox',
    'storage': 'Storage',
    'storageLink': '▸ Storage',
    'articleTypes': 'Article Types',
    'stock': 'Stocks',
    'deliveryArchive': 'Delivery Archive',
    'salesReport': 'Sales Report',
    'b2cOrders' : 'Orders',

    'search': 'Search...',
    'filterArticles': 'Filter Articles',
    'filterTransactions': 'Filter Deliveries',
    'filter': 'Filter',
    'export': 'Export',

    'save': 'Save',
    'confirm': 'Confirm',
    'abort': 'Abort',
    'saveDraft': 'Save Draft',
    'sendTransaction': 'Dispatch Delivery',

    'addDeliveryOrder': 'New Delivery',
    'addArticleType': 'New Article Type',
    'updateArticleType': 'Edit Article Type',
    'addStock': 'New Stock Entry',
    'addStockCorrection': 'Stock Correction',
    'showAllArticles': 'Show All Articles',
    'showStockTransactions': 'Show Stock Transactions',
    'showEmptyStocks': 'Show Empty Stocks',
    'showNonEmptyStocks': 'Only Show Full Stocks',
    'all_articleTypes': 'All_ArticleTypes',
    'annotationDelivery': 'Annotations to the Delivery',
    'annotationStock': 'Annotations to the Stock Change',
    'selectArticleType': 'Select Article Type',
    'editTransaction': 'Edit Delivery',
    'deleteTransaction': 'Delete Delivery',
    'outgoing_transactions': 'Outgoing_Deliveries',
    'incoming_transactions': 'Incoming_Deliveries',
    'correction': 'Correction',
    'newCorrection': 'New Correction',

    'chooseTimeframe': 'Select Timespan:',
    'allSalepoints': 'All Outlets',
    'loadReport': 'Load Report',

    'reset': 'Zurücksetzen',
    'manually': 'Manuell',
    'today': 'Heute',
    'days7': '7 Tage',
    'days14': '14 Tage',
    'days30': '30 Tage',
    'monthThis': 'Dieser Monat',
    'monthLast': 'Letzter Monat',
    'yearThis': 'Dieses Jahr',
    'all': 'Alle',

    //'deliverySource': 'Departure',
    //'deliveryTarget': 'Destination',
    'deliverySource': 'Source',
    'deliveryTarget': 'Target',
    'deliverySourceOrTarget': 'Delivery Source/Target',
    'creationDate': 'Creation Date',
    'state': 'State',
    'type': 'Type',
    'remark': 'Remark',

    'view': 'View',
    'articleNumberDesigner': 'Article no. Designer',
    'articleNumberFaex': 'Article no. FAEX',
    'articleNumber': 'Artikelnummer',
    'articleType': 'Article Type',
    'colour': 'Colour',
    'size': 'Size',
    'totalAmount': 'Total',
    'externalAmount': 'External',
    'soldAmount': 'Sold',
    'storageAmount': 'Storage',
    'salePrice': 'Sale Price',
    'price': 'Price',
    'salePriceAbb': 'Sale Price',
    'purchasePrice': 'Purchasing Price',
    'name': 'Name',
    'gender': 'Gender',
    'sizeCategory': 'Size Category',
    'description': 'Description',
    'sum': 'Total',

    'external': 'External:',
    'sold': 'Sold:',
    'where': 'Where',
    'howMany': 'How many',
    'correctedOrReturned': 'Corrected/Returned',
    'correctedBy': 'Corrected by',
    'correctionDate': 'Correction Date',
    'yes': 'Yes',

    'salePoint': 'Outlet',
    'saleDate': 'Sale Date',
    'articleName': 'Article Name',
    'amount': 'Amount',
    'defaultSalePrice': 'Original Price',
    'paymentGross': 'Payment gross to Designer (60%)',
    'paymentNet': 'Payment net to Designer',
    'orderNumber': 'Ordernumber',
    'orderState': 'Order state',
    'orderProcessingState': 'Order processing state',



    'error': 'Internal Error!',
    'errorMessage': 'An error occured. Please contact an administrator.',
    'errorImage': 'The format of the image is incorrect.',
    'errorCorrectionValues': 'Corrected values must not have a negative balance.',
    'errorEmptyValue': 'At least one values needs to be set.',
    'errorInvalidAmount1': 'The articles to be shipped for: ',
    'errorInvalidAmount2': 'do not match with the stock. The following information is incorrect: ',
    'errorStocks': 'The article searched for could not be found in stock.',

    'news': 'News',
    'greeting_short': 'Welcome, ',
    'greeting_long': 'Welcome, User!',
    'nowNews': 'There is no news at the moment.',

    'addCorrection': 'Add Correction',
    'submitCorrection': 'Confirm Correction',
    'submitCorrection2': 'Do you want to confirm the correction?',
    'submitDelivery': 'Confirm Delivery',
    'submitDelivery2': 'Do you want to accept the delivery? \n Afterwards, corrections are no longer possible.',
    'submitDelivery3': 'Do you want to cache or submit the delivery? Once submitted, the delivery can no longer be edited!',
    'submitDeliveryIncome': 'Confirm Arrival',
    'submitDeliveryIncome2': 'Do you want to confirm the arrival of the delivery?',
    'submitEditing': 'Confirm Editing',
    'submitEditing2': 'Do you want to start editing the delivery to add corrections?',
    'updateStock': 'Update Stock',
    'updateStock2': 'Do you want to update the stock by the given articles? You can cache or submit the stock update. Once submitted, changes are no longer possible!',

    'orderStateFiltering': '- filter order status -',
    'orderProgressStateFiltering': '- filter order progress status -',
    'OrderRegistered': 'Order registered',
    'OrderInProgress': 'Order in progress',
    'OrderCanNotBeDelivered': 'Order can not be delivered',
    'OrderArrivedFAEX': 'Order arrived at FAEX',
    'OrderCanBeShipped': 'Order can be shipped',
    'OrderShipped': 'Order shipped',
    'OrderWillBePickedUp': 'Order will be picked up',
    'OrderWasPickedUpByCustomer': 'Order was picked up by customer',
    'OrderReturned': 'Order returned',
    'OrderCanceled': 'Order cancelled',
    'OrderPaymentWaitingForReturn': 'Order payment waiting for return',
    'OrderPaymentReturned': 'Order payment returned',
    'OrderComplete': 'Order complete',
    'OrderAssumesReturnPolicy': 'Order assumes return policy',
    'OrderCompletedAndReadyForAccountBooks': 'Order completed and booked',
    'NA': 'NA',

    'Designer': 'Designer',
    'Boutique': 'Boutique',
    'FAEX': 'FAEX',

    'search...': 'Search for...',
    'filteringOptions' : 'Filtering options',
    'allOrderedArticles' : 'All ordered articles',
    'particularOrder': 'Full order',
    'particularOrderClose': 'Close',
    'particularOrderPositionOpen': 'Open ordered article',

    'manageOrder': 'Manage order',
    'label': 'Label',
    'dateOfOrdering': 'Date of ordering',
    'orderStatus': 'Order state',
    'prototype': 'Type of article',
    'orderProcessingStatus': 'Status of order processing',
    'unitPrice': 'Price per unit',
    'prepayment': 'Prepayment',
    'priceIncrement' : 'Increment in price',
    'placeOfOrdering': 'Place of ordering',
    'paymentTypeForPrepayment': 'Type of prepayment',
    'outstandingBalance': 'Outstanding balance',
    'paymentDueTo': 'Payment due',
    'paymentMethodForBillDue': 'Type of payment (bill due)',
    'deliveredViaAgend': 'Delivery agent',
    'customer': 'Customer',
    'refundDate': 'Date of refund',
    'billnumber': 'Billnumber',
    'orderedAtDesigner': 'Ordered at designer\'s',
    'deliveredToFAEX': 'Delivered to FAEX',
    'dispatchedToCustomer': 'Dispatched to customer',
    'dispatchedToBoutique': 'Dispatched to boutique',
    'retouredByCustomer': 'Retoured by customer',
    'pickedUpByCustomer': 'Picked up by customer',
    'remarkPart1': 'Remark',
    'remarkPart2': ' to ',
    'remarkPart3': 'to designer',
    'remarkPart4': ' and ',
    'remarkPart5': ' from ',
}